export enum CrmLifecycleStatus {
    Database = 'database',
    Pipeline = 'pipeline',
    ExistingCustomer = 'existing_customer',
    Rejection = 'rejection',
    Archive = 'archive',
}
